// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3YxDH","logo":"styles_logo__3ECf3"};